import { render, staticRenderFns } from "./Zaun24Compare.vue?vue&type=template&id=3a8c48b5"
import script from "./Zaun24Compare.vue?vue&type=script&lang=js"
export * from "./Zaun24Compare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports